
import './libs/modernizr.js';
import './libs/bootstrap';

// JS class helper
var body = document.querySelector('body');
body.classList.add('js');

// To top body class helper
// window.onscroll = function(e) {
//     if (window.pageYOffset > 500) {
//         body.classList.add('show-to-top');
//     } else {
//         body.classList.remove('show-to-top');
//     }
// };

// Touch body class helper
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    body.classList.add('touch');
}

require('./modules/headroom')
require('./modules/lazy-load')
require('./modules/slider')
require('./modules/slick-swiper')
require('./modules/map')
require('./modules/ajax-form-handler')
require('./modules/aos')
require('./modules/sidebars')
require('./modules/ibe')
require('./modules/ajax-posts')
require('./libs/jquery.lbt-lightbox.js')
require('./modules/lightbox')
require('./modules/customjs')

// Stimulus
import { Application } from "stimulus"

import DelayVisibilityController from "./controllers/delay_visibility_controller"
import ProgressController from "./controllers/progress_controller"
import SnapScrollingController from "./controllers/snap_scrolling_controller"

const application = Application.start()
application.register("delay-visibility", DelayVisibilityController)
application.register("progress", ProgressController)
application.register("snap-scrolling", SnapScrollingController)


jQuery(document).on('click', '#load-more', function(e) {
 e.preventDefault(); // verhindert das Standardverhalten des <a>-Tags
    var button = jQuery(this);
    var page   = button.data('page');
   var letter = button.data('letter');
    var lastLetter = jQuery('#profession-container .card').last().data('letter');
console.log('OK');
    jQuery.ajax({
        url: '/wp-admin/admin-ajax.php', // WP stellt ajaxurl automatisch bereit
        type: 'POST',
        data: {
            action: 'load_professions',
            page: page,
            letter: letter, // '' = kein Filter
           lastLetter: lastLetter
        },
        success: function(response) {
            button.closest('div').remove();
            jQuery('#profession-container').append(response);
        }
    });


});


jQuery(document).on('click', '.alphabetfilter', function(e) {
    e.preventDefault();

    var text = jQuery(this).text().trim();
    var letter = (text === 'Alle') ? '' : text; // Filter leeren wenn "Alle"

    jQuery.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
            action: 'load_professions',
            page: 1,       // immer bei Seite 1 starten
            letter: letter // '' = kein Filter
        },
        success: function(response) {
            jQuery('#profession-container').html(response);
        }
    });
});

jQuery(document).on('click', '.co_alphabetfilter', function(e) {
    e.preventDefault();

    var text = jQuery(this).text().trim();
    var letter = (text === 'Alle') ? '' : text; // Filter leeren wenn "Alle"

    jQuery.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
            action: 'load_company',
            page: 1,       // immer bei Seite 1 starten
            letter: letter // '' = kein Filter
        },
        success: function(response) {
            jQuery('#company_container').html(response);
        }
    });
});



// document.addEventListener('DOMContentLoaded', () => {
//     if (document.querySelector('#job_beginn_btn')) {
//   document.querySelector('#job_beginn_btn').addEventListener('click', () => {
//     openDatepicker('job_beginn');
//   });
// }
// });

// document.addEventListener('DOMContentLoaded', () => {
//     if (document.querySelector('#job_pub_beginn_btn')) {
//   document.querySelector('#job_pub_beginn_btn').addEventListener('click', () => {
//     openDatepicker('job_pub_beginn');
//   });
//   }
// });

// document.addEventListener('DOMContentLoaded', () => {
//     if (document.querySelector('#job_pub_ende_btn')) {
//   document.querySelector('#job_pub_ende_btn').addEventListener('click', () => {
//     openDatepicker('job_pub_ende');
//   });
//   }
// });


let currentYear, currentMonth, currentTargetId;

function openDatepicker(targetId) {
  const dp = document.getElementById('datepickerLupo');
  dp.style.display = 'block';
  const today = new Date();
  currentYear = today.getFullYear();
  currentMonth = today.getMonth();
  currentTargetId = targetId;
  buildCalendar(currentYear, currentMonth);
}

function buildCalendar(year, month) {
  const dp = document.getElementById('datepickerLupo');
  dp.innerHTML = '';

  // Navigation
  const nav = document.createElement('div');
  nav.className = 'navRow';
  const prev = document.createElement('span');
  prev.textContent = '<';
  prev.onclick = () => {
    if (month === 0) { currentMonth = 11; currentYear--; }
    else { currentMonth--; }
    buildCalendar(currentYear, currentMonth);
  };
  const label = document.createElement('span');
  label.textContent = `${year}-${String(month+1).padStart(2,'0')}`;
  const next = document.createElement('span');
  next.textContent = '>';

  next.onclick = () => {
    if (month === 11) { currentMonth = 0; currentYear++; }
    else { currentMonth++; }
    buildCalendar(currentYear, currentMonth);
  };
  nav.appendChild(prev);
  nav.appendChild(label);
  nav.appendChild(next);
  dp.appendChild(nav);

  // Kalender
  const date = new Date(year, month, 1);
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const startDay = date.getDay(); // 0=Sonntag

  const table = document.createElement('table');
  const headerRow = document.createElement('tr');
  const days = ['So','Mo','Di','Mi','Do','Fr','Sa'];
  days.forEach(d => {
    const th = document.createElement('th');
    th.textContent = d;
    headerRow.appendChild(th);
  });
  table.appendChild(headerRow);

  let row = document.createElement('tr');
  for (let i=0; i<startDay; i++) {
    row.appendChild(document.createElement('td'));
  }

  for (let d=1; d<=daysInMonth; d++) {
    const td = document.createElement('td');
    td.textContent = d;
    td.onclick = () => {
      const targetInput = document.getElementById(currentTargetId);
      targetInput.value = `${String(d).padStart(2,'0')}.${String(month+1).padStart(2,'0')}.${year}`
      dp.style.display = 'none';
    };
    row.appendChild(td);
    if ((startDay + d) % 7 === 0) {
      table.appendChild(row);
      row = document.createElement('tr');
    }
  }
  table.appendChild(row);
  dp.appendChild(table);
}

